import UserAccountsPage, { type UserAccountEntry } from "../components/UserAccountsPage";

export interface UserAccountsJSPProps {
  results: UserAccountEntry[];
  totalAmount: number;
  manageUserLink: string;
}

export function create(json: string) {
  const data: UserAccountsJSPProps = JSON.parse(json);

  return <UserAccountsPage {...data} unit={window.SCHA.user.selectedAccount ?? EMPTY_UNIT} />;
}

const EMPTY_UNIT = { displayUid: "NA", name: "N/A" };
